module.exports = __webpack_public_path__ + "static/media/tap_button4_img.cc1dfc64.png";